import { VestingInfoResponse } from '../store/vestingInfo/actions/getVestingInfo';
import {
  deployVestingClaim,
  getUnlockResult,
  getVestingClaimResult,
  getVestingInfo
} from '@brickken/web3';
import { Claim } from '../models/Claim';
import { TransactionStatus } from '../models/Transaction';

export const fetchVestingInfo = async (
  vestingContractAddresses: string[]
): Promise<VestingInfoResponse> => {
  return getVestingInfo(vestingContractAddresses);
};
export const createClaim = async (
  vestingContractAddress: string,
  claim: Claim
): Promise<Claim> => {
  const txHash = await deployVestingClaim(vestingContractAddress);
  return {
    ...claim,
    claim: {
      txHash,
      status: TransactionStatus.Init
    },
    status: TransactionStatus.Pending
  };
};
export const watchClaim = async (claim: Claim): Promise<Claim> => {
  await getVestingClaimResult(claim?.claim.txHash);
  return {
    ...claim,
    claim: {
      ...claim.claim,
      status: TransactionStatus.Success
    }
  };
};
